import { render, staticRenderFns } from "./card-pagination.vue?vue&type=template&id=175bc0d2&scoped=true&"
import script from "./card-pagination.vue?vue&type=script&lang=js&"
export * from "./card-pagination.vue?vue&type=script&lang=js&"
import style0 from "./card-pagination.vue?vue&type=style&index=0&id=175bc0d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bc0d2",
  null
  
)

export default component.exports